import { Component, forwardRef, OnInit } from '@angular/core';
import { DynamicComponentBase, IDynamicComponentConfig } from '../../../dynamic-component';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-d-radio',
  templateUrl: './d-radio.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => DRadioComponent),
      multi: true
    }
  ]
})
export class DRadioComponent extends DynamicComponentBase {
  static KEY = 'd-radio';

  constructor() {
    super();
  }

  configChange(config: IDynamicComponentConfig) {
    if (!Array.isArray(config.dataSource)) {
      config.dataSource = [
        {
          value: '1',
          label: '选项1'
        },
        {
          value: '2',
          label: '选项2'
        },
        {
          value: '3',
          label: '选项3'
        }
      ];
    }
  }
}
